import React, { useState } from "react"
import { verifyEmail, createHrLead, setSessionEmail } from "../services/aiTryService"

// Email/name gate shown on first "Try" click. On success it sets the session
// and hands the verified email back to the carousel to continue the action.
const AIEmailGate = ({ onVerified }) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  const handleSubmit = async e => {
    e.preventDefault()
    setError("")
    setLoading(true)
    const form = new FormData(e.target)
    const name = form.get("name")
    const email = form.get("email")
    try {
      const valid = await verifyEmail(email)
      if (!valid) {
        setError("Your email seems invalid. Please use a valid email.")
        setLoading(false)
        return
      }
      const created = await createHrLead({ name, email })
      if (!created) {
        setError("Something went wrong. Please try again.")
        setLoading(false)
        return
      }
      setSessionEmail(email)
      // Hand off to the carousel, which increments usage and opens the demo.
      // Returns true on success, or an error string if it couldn't start.
      const result = await onVerified(email)
      if (result !== true) {
        setError(typeof result === "string" ? result : "Couldn't start the demo. Please try again.")
        setLoading(false)
      }
    } catch (err) {
      console.error("Email gate error:", err)
      setError("Something went wrong. Please try again.")
      setLoading(false)
    }
  }

  return (
    <div className="aitry-gate">
      <div className="aitry-gate__row">
        <div className="aitry-gate__text">
          <h1 className="aitry-gate__title">Revolutionizing Customer Interaction with AI.</h1>
          <p className="aitry-gate__sub">
            Maximize your return on investment with AI chatbots that drive sales, reduce operational
            costs, and unlock new revenue streams for your growing business.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="aitry-gate__form">
          <div className="aitry-gate__field">
            <label className="aitry-gate__label">Full Name</label>
            <input type="text" name="name" className="aitry-gate__input" required />
          </div>
          <div className="aitry-gate__field">
            <label className="aitry-gate__label">Email</label>
            <input type="email" name="email" className="aitry-gate__input" required />
          </div>
          {error && <span className="aitry-gate__error">{error}</span>}
          <button type="submit" disabled={loading} className="aitry-gate__submit">
            {loading ? <span className="aitry-loader aitry-loader--light" /> : "Access Demos"}
          </button>
          {loading && (
            <span className="aitry-gate__hint">Please wait — verifying your email address.</span>
          )}
        </form>
      </div>
      <div className="aitry-gate__banner" role="note">
        <strong>Trial limit</strong> — each user gets <strong>2 chats</strong> and{" "}
        <strong>1 call (max 3 min)</strong> per agent. To explore further, reach out to the{" "}
        <a href="https://www.visiomate.com/contact" target="_blank" rel="noopener noreferrer">
          Visiomate team
        </a>
        . These limits ensure fair access and a consistent experience for all users.
      </div>
    </div>
  )
}

export default AIEmailGate
